import React from "react";

const WhyChooseUs = () => {
  const features = [
    {
      title: "Safe & Comfortable Rides",
      description:
        "Experienced drivers and sanitized vehicles to ensure your safety and comfort.",
      icon: (
        <svg
          className="w-8 h-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 10h1l1 2h12l1-2h1M5 16h14l1 2H4l1-2z"
          ></path>
        </svg>
      ),
    },
    {
      title: "Affordable Pricing",
      description: "Transparent fares with no hidden charges to fit your budget.",
      icon: (
        <svg
          className="w-8 h-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 8c-3 0-5 1.5-5 4s2 4 5 4 5-1.5 5-4-2-4-5-4z"
          ></path>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 12v4"
          ></path>
        </svg>
      ),
    },
    {
      title: "24/7 Availability",
      description: "Book a cab anytime, day or night, we’re always here.",
      icon: (
        <svg
          className="w-8 h-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 8v4l3 3"
          ></path>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        </svg>
      ),
    },
    {
      title: "Easy Booking Process",
      description:
        "Quick and hassle-free ride booking with our intuitive interface.",
      icon: (
        <svg
          className="w-8 h-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      ),
    },
  ];

  return (
    <section className="py-16 bg-gray-50 px-6 lg:px-24">
      <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
        Why Choose Us
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
        {features.map(({ title, description, icon }, idx) => (
          <div
            key={idx}
            className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition"
          >
            <div>{icon}</div>
            <div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900">{title}</h3>
              <p className="text-gray-600">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
